<template>
  <div v-if="basket" class="card checkout-summary bg-white round drop-shadow">
    <div class="card-header">
      <h6 class="mb-0">Order Summary</h6>
    </div>
    <div class="card-body">
      <h4>
        <span>Items: <span class="muted-text" v-if="showVat && basket.vat_total > 0">inc. VAT</span></span>
        <span>&pound;{{ basket.original_total ? basket.original_total : basket.total | money }}</span>
      </h4>
      <h4>
        <span>Delivery: <span class="muted-text" v-if="showVat && deliveryVat > 0">inc. VAT</span></span>
          <span id="delivery-total" v-if="deliveryTotal === 'FREE'">{{ deliveryTotal }}</span>
          <span id="delivery-total" v-else>£{{ deliveryTotal | money }}</span>
      </h4>
    </div>
      <div :class="((basket.gift_cards && basket.gift_cards.length > 0) || (basket.discount_total < 0 || basket.voucher_code)) ? 'd-block' : 'd-none'" class="mt-1 card-vouchers">
          <h4 class="d-flex" v-if="basket.gift_cards && basket.gift_cards.length > 0">
              <span>Gift Vouchers:</span>
              <div>
                  <p class="mb-0" v-for="gift_card in basket.gift_cards">£-{{gift_card.amount_pending | money}}</p>
              </div>
          </h4>

          <h4 :class="(basket.discount_total < 0 || basket.voucher_code) ? 'd-flex' : 'd-none'">
              <span>Discount:</span>
              <span id="discount-total">
              &pound;{{ discountTotal | money }}
            </span>
          </h4>
          <h6 v-if="basket.voucher_code" class="mt-1 mb-0">{{ basket.voucher_code }} <span class="remove-voucher-button ml-2" @click="removeVoucher()">X</span></h6>
      </div>
    <div class="card-footer">
      <h4 :class="showVat && totalVat > 0 ? 'showingVat' : ''">
        <span>Total:</span>
        <span>&pound;{{ grandTotal | money }}</span>
      </h4>
        <h5 class="d-flex justify-content-between" v-if="showVat && totalVat > 0">
            <span>Which includes VAT of:</span>
            <span>&pound;{{ totalVat | money }}</span>
        </h5>
      <button v-if="showButton" class="btn btn-primary btn-block" @click="nextStep()" id="continueButton">
        Continue
        <i class="fas fa-arrow-right"></i>
      </button>
    </div>
  </div>
</template>

<script>
import {EventBus} from "../../../app";
export default {
  data() {
    return {
        hasFreeShipping: false,
    };
  },

  props: {
    basket: {
      type: Object,
    },
    continueUrl: {
      type: String,
    },
    voucher: {
        type: Object,
    },
    shippingMethodPrice: {
        type: Number,
    },
  },

    created() {
        EventBus.$on('freeShippingEnabled', this.freeShippingEnabled);
    },
    destroyed() {
        EventBus.$off('freeShippingEnabled', this.freeShippingEnabled);
    },

  computed: {
      showButton() {
          return window.location.pathname !== '/checkout/payment';
      },
      showVat() {
          return window.location.pathname !== '/checkout/delivery';
      },
      deliveryVat() {
          return Number(this.basket.delivery_total_inc_vat) - Number(this.basket.delivery_total_ex_vat);
      },
      totalVat() {
          return this.deliveryVat + Number(this.basket.vat_total);
      },
      deliveryTotal() {
          if (this.basket.delivery_total_inc_vat > 0 && (!this.hasFreeShipping || (!this.voucher))) {
              return this.basket.delivery_total_inc_vat;
          } else if (this.hasFreeShipping || (this.voucher && this.voucher.voucher_type_id == 3)) {
              return this.shippingMethodPrice;
          } else {
              return 'FREE';
          }
      },
      discountTotal() {
        if (this.hasFreeShipping || (this.voucher && this.voucher.voucher_type_id == 3)) {
            return '-' + this.shippingMethodPrice;
        } else {
            return this.basket.discount_total_inc_vat;
        }
      },
      grandTotal() {
          if(this.basket.gift_cards.length > 0) {
              let totalGiftCardAmount = this.basket.gift_cards.reduce((sum, gift_card) => {
                  return sum + gift_card.amount_pending;
              }, 0);

              let adjustedGrandTotal = this.basket.grand_total - totalGiftCardAmount;
              adjustedGrandTotal = Math.max(adjustedGrandTotal, 0);

              return adjustedGrandTotal;
          } else {
              return this.basket.grand_total
          }
      }
  },

  methods: {
      nextStep() {
          if (window.location.pathname === '/checkout/summary') {
              return document.querySelector("button#opayo_button").click();
          }
          return window.location.href = this.continueUrl;
      },

      removeVoucher() {
          EventBus.$emit('removeVoucher');
          this.hasFreeShipping = false;
      },

      freeShippingEnabled() {
          this.hasFreeShipping = true;
          //this.updateDeliveryAndDiscounts();
      },

      // updateDeliveryAndDiscounts() {
      //     if(this.basket && this.basket.discount_total && !this.hasFreeShipping) {
      //         console.log('no free shipping')
      //         this.discountTotal = this.basket.discount_total;
      //     }
      //
      //     if (this.basket.delivery_total_inc_vat > 0) {
      //         console.log('test');
      //         this.deliveryTotal = this.basket.delivery_total_inc_vat;
      //     } else if (this.hasFreeShipping) {
      //         console.log('freeshipping')
      //         this.deliveryTotal = this.shippingMethodPrice;
      //     } else {
      //         console.log('delivery total here')
      //         this.deliveryTotal = 'FREE';
      //     }
      // }
  },
};
</script>
